﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { config } from '../../assets/config';
import {Word} from '../_models/word';

@Injectable()
export class WordService {
    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<Word[]>(`${config.apiUrl}/words`);
    }

    getById(id: number) {
        return this.http.get(`${config.apiUrl}/words/` + id);
    }

    getByIntercalaireId(intercalaireId: string) {
        return this.http.get(`${config.apiUrl}/intercalaires/` + intercalaireId + '/words');
    }

    getByPatientId(patientId: string) {
        return this.http.get(`${config.apiUrl}/words?filter={"where":{"patientId":"${patientId}"}}`);
    }

    register(word: Word) {
        return this.http.post(`${config.apiUrl}/words`, word);
    }

    registerByIntercalaireId(intercalaireId: string, word: Word) {
        return this.http.post(`${config.apiUrl}/intercalaires/` + intercalaireId + '/words', word, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    registerByCategoryId(categoryId: string, word: Word) {
        return this.http.post(`${config.apiUrl}/categories/` + categoryId + '/words', word, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    registerBySubCategoryId(subCategoryId: string, word: Word) {
        return this.http.post(`${config.apiUrl}/subCategories/` + subCategoryId + '/words', word, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    assignAdditionalFile(wordId, url, type, thumb) {

        const data = {
            url,
            type,
            thumb
        }
        return this.http.post(
            `${config.apiUrl}/words/` + wordId + '/additionalFiles',
            data,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );
    }

    getAdditionalFiles(wordId: string) {
        return this.http.get(`${config.apiUrl}/words/` + wordId + '/additionalFiles');
    }

    move(wordId: string, intercalaireId: string, categoryId:string, subCategoryId: string) {

        let data = {
          intercalaireId,
          categoryId,
          subCategoryId
        }

        return this.http.patch(`${config.apiUrl}/words/` + wordId, data, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        });
    }

    update(word: Word) {
        return this.http.put(`${config.apiUrl}/words/` + word.id, word, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        });
    }

    delete(id: string) {
        return this.http.delete(`${config.apiUrl}/words/` + id);
    }

    deleteAdditionalFiles(id: string) {
        return this.http.delete(`${config.apiUrl}/words/` + id + '/additionalFiles');
    }
}
